import { createReducer } from '@reduxjs/toolkit';
import { getEmployeeAuditLogsAction, setAuditLogsRequestsLoadingAction } from 'store/actions/audit-log-actions';
import IAuditLogState from 'types/auditlogs/IAuditLogState';

const initialState: IAuditLogState = {
  loading: false,
  employeeAuditLogs: [],
};

const auditLogsReducer = createReducer(initialState, builder => {
  return builder
    .addCase(setAuditLogsRequestsLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(getEmployeeAuditLogsAction, (state, action) => ({ ...state, employeeAuditLogs: action.payload }));
});

export default auditLogsReducer;
